import { DeviceTypes } from '@eppendorf/app-configs';
import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import {
  EscalationLayer,
  NotificationRule,
  NotificationRuleCategory,
  EventSeverity,
  NotificationRuleNotificationType,
} from '@eppendorf/vnls-notifications-utils';
import { AxiosError } from 'axios';
import { UseFormReturn } from 'react-hook-form';

export interface EscalationLayerWithMode extends EscalationLayer {
  mode: NotificationRuleEscalationLayerMode;
}

export type NotificationRuleSubmitForm = {
  notificationRuleName: string;
  devices: { id: string; value: string; model?: string }[];
  escalationLayers: EscalationLayerWithMode[];
  selectedDeviceType: DeviceTypes;
  conditionMode: NotificationRuleConditionMode;
  tags: EventSeverity[];
  categories: NotificationRuleCategory[];
  notificationCadence: number;
  notificationSendDelaySeconds: number;
  notificationTypes: NotificationRuleNotificationType[];
};

export type CreateNotificationRuleInput = Pick<
  NotificationRule,
  | 'name'
  | 'selectedDeviceType'
  | 'subjects'
  | 'escalationLayers'
  | 'tags'
  | 'categories'
  | 'notificationCadence'
  | 'notificationSendDelaySeconds'
  | 'notificationTypes'
>;

export type UpdateNotificationRuleInput = {
  id: string;
} & Partial<CreateNotificationRuleInput>;

export enum NotificationRuleConditionMode {
  BASIC = 'basic',
  ADVANCED = 'advanced',
}

export enum NotificationRuleEscalationLayerMode {
  STOP = 'stop',
  ESCALATE = 'escalate',
}

export enum NotificationRuleMode {
  EDIT = 'edit',
  CREATE = 'create',
}
export type AvailableScreenProps = {
  key: AddOrEditNotiRuleModalScreens;
  fields: Array<keyof NotificationRuleSubmitForm>;
};

export interface NotificationRuleDialogContentProps {
  data?: NotificationRuleDetailData;
  handleFormSubmit: (data: NotificationRuleSubmitForm) => Promise<void>;
  isLoading: boolean;
  requestError: AxiosError;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any -- we know it exists */
  formMethods: UseFormReturn<NotificationRuleSubmitForm>;
  initialScreen?: AddOrEditNotiRuleModalScreens;
  onScreenChange?: (screen: AddOrEditNotiRuleModalScreens) => void;
}

export interface NotificationRuleDialogContentHandle {
  /** Navigates to the given screen, but only if it was already visited (i.e. it precedes the currently active screen). */
  goToScreen: (screen: AddOrEditNotiRuleModalScreens) => void;
}

export interface AddNotificationRuleScreenProps {
  formControl: UseFormReturn<NotificationRuleSubmitForm>;
}

export type AddOrEditNotiRuleModalScreens =
  | 'deviceTypeScreen'
  | 'devicesScreen'
  | 'conditionScreen'
  | 'recipientsScreen'
  | 'lifecycleScreen'
  | 'nameScreen'
  | 'successScreen'
  | 'errorScreen';

export interface Severity {
  name: 'error' | 'alert' | 'warning' | 'info';
}

export type NotificationRuleDetailData = NotificationRule & {
  devices: {
    details: DeviceDTO[];
    errors: string[];
  };
};
